import React from 'react';

export interface BreadcrumbItem {
  href?: string;
  label: string;
}

interface Props {
  items: BreadcrumbItem[];
  largerFont?: boolean;
}

// This is a React Component that was converted from code in breadcrumbs_helper.rb
const Breadcrumbs = ({ items, largerFont = false }: Props) => {
  const containerClassName = largerFont
    ? 'breadcrumbs tw-flex tw-items-center tw-text-sm tw-mb-0'
    : 'breadcrumbs';

  return (
    <div className={containerClassName}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast) {
          const labelClassName = largerFont
            ? 'bold tw-text-[#555] tw-font-medium'
            : 'bold';

          return (
            <span
              key={`breadcrumb-item-label-${item.label}`}
              className={labelClassName}
            >
              {item.label}
            </span>
          );
        }

        const linkClassName = largerFont
          ? `tw-text-purple tw-text-sm hover:tw-underline
             tw-text-ellipsis tw-nowrap tw-overflow-hidden
             tw-whitespace-nowrap tw-max-w-[14rem] chromebook-plus:tw-max-w-none`
          : '';

        return (
          <React.Fragment key={`breadcrumb-item-${item.label}`}>
            <a
              className={linkClassName}
              href={item.href}
            >
              {item.label}
            </a>
            {largerFont ? (
              <i className="fa fa-caret-right tw-mx-2 tw-text-black tw-text-lg" />
            ) : (
              <span> / </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
